import { Box, Divider } from '@wix/design-system';
import React, { FC } from 'react';
import { useSelector } from 'react-redux';

import { selectResourcesSection } from '../../../common/selectors/homepage';
import { SectionComponentProps } from '../types';
import { ExternalResourcesItem } from './ExternalResourcesItem';

export const ExternalResources: FC<SectionComponentProps> = ({
  positionIndex,
}) => {
  const resourcesSection = useSelector(selectResourcesSection);
  const resourcesSectionItems = resourcesSection?.items ?? [];

  if (resourcesSectionItems.length === 0) {
    return null;
  }

  return (
    <Box direction="vertical">
      {resourcesSectionItems.map((item, index) => (
        <>
          <ExternalResourcesItem
            key={item.resourceId}
            resourceSection={item}
            blockPositionIndex={positionIndex}
            index={index}
          />
          {index !== resourcesSectionItems.length - 1 && <Divider />}
        </>
      ))}
    </Box>
  );
};
